import api from "./client"
import type { Routine } from "../types"

export async function getRoutines(params: { date?: string; userId?: number } = {}): Promise<Routine[]> {
  const query: Record<string, unknown> = {}
  if (params.date) query.date = params.date
  if (params.userId) query.user_id = params.userId
  const { data } = await api.get<Routine[]>("/routines", { params: query })
  return data
}

export async function getRoutine(id: number): Promise<Routine> {
  const { data } = await api.get<Routine>(`/routines/${id}`)
  return data
}

export async function createRoutine(
  params: Record<string, unknown>,
  userId?: number
): Promise<Routine> {
  const body: Record<string, unknown> = { routine: params }
  if (userId) body.user_id = userId
  const { data } = await api.post<Routine>("/routines", body)
  return data
}

export async function updateRoutine(
  id: number,
  params: Record<string, unknown>,
  userId?: number
): Promise<Routine> {
  const body: Record<string, unknown> = { routine: params }
  if (userId) body.user_id = userId
  const { data } = await api.patch<Routine>(`/routines/${id}`, body)
  return data
}

export async function deleteRoutine(id: number, userId?: number): Promise<void> {
  await api.delete(`/routines/${id}`, { params: userId ? { user_id: userId } : {} })
}

export async function getTemplates(): Promise<Routine[]> {
  const { data } = await api.get<Routine[]>("/routines/templates")
  return data
}
